import { UPDATE_APPOINTMENT } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_APPOINTMENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_APPOINTMENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_APPOINTMENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
